import { CompanyApi as CompanyApiV2 } from "@vintecc/capture-api-types/v2";
import { CompanyApi } from "@vintecc/capture-api-types/v1";
import captureApiConfiguration from "./configuration.api";

const company = {
  v1: new CompanyApi(captureApiConfiguration),
  v2: new CompanyApiV2(captureApiConfiguration),
};

export default company;
